<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiDotsGrid } from "@mdi/js";
export default {
  name: "MdiDotsGrid",
  data() {
    return {
      svgPath: mdiDotsGrid,
    };
  },
};
</script>
